import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { filter, map, switchMap } from 'rxjs/operators';
import { TicketPrice } from 'src/app/interfaces/interfaces';
import { DashboardLogicService } from 'src/app/logic/dashboard.service';
import { EventLogicService } from 'src/app/logic/event-service';
import { PassDataService } from 'src/app/services/pass-data.service';

@Component({
  selector: 'app-add-event',
  templateUrl: './add-event.component.html',
  styleUrls: ['./add-event.component.scss']
})
export class AddEventComponent implements OnInit {

  _id: string = '';
  title: string = '';
  description: string = '';
  actualPrice: string = "";
  discountedPrice: string = "";
  location: string = "";
  startDate: string = "";
  endDate: string = "";
  ticketType: string = "";
  ticketPrice: TicketPrice[] = [];
  registerLink: string = "";
  imageUrls: string[] = [];
  private files: any = [];
  state: any = '';
  isViewImage: boolean = true;

  filesCount: number[] = [1];

  constructor(
    private eventLogicService: EventLogicService,
    private passDataService: PassDataService,
    private dashboardLogicService: DashboardLogicService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.state = window.history.state;
    if (this.state.data) {
      if (this.state.isEdit || this.state.isView) {
        this.title = this.state.data.title;
        this.description = this.state.data.description;
        this._id = this.state.data._id;
        this.actualPrice = this.state?.data?.ticketPrice[0]?.actualPrice
        this.discountedPrice =this.state.data?.ticketPrice[0]?.discountedPrice
        this.location = this.state.data.location;
        this.startDate = this.state.data.startDate;
        this.endDate = this.state.data.endDate
        this.ticketType = this.state.data.ticketType
        this.ticketPrice = this.state.data.ticketPrice
        this.registerLink = this.state.data.registerLink
        this.imageUrls = this.state.data.imageUrls
      }
    }
  }

  imageFileOutput(file: any) {
    this.files.push(file.item(0))
  }

  onAddAnotherImage(file: any) {
    this.filesCount.push(this.filesCount.length + 1)
  }

  setTitle(title: string) {
    this.title = title;
  }

  setDescription(description: string) {
    this.description = description;
  }

  setActualPrice(price: string) {
    this.actualPrice = price;
  }

  setDiscountedPrice(price: string) {
    this.discountedPrice = price;
  }

  setLocation(location: string) {
    this.location = location;
  }

  setStartDate(date: string) {
    this.startDate = date;
  }

  setEndDate(date: string) {
    this.endDate = date;
  }

  setTicketType(type: string) {
    this.ticketType = type;
  }

  setRegisterLink(link: string) {
    this.registerLink = link;
  }

  async onAddClick() {
    this.passDataService.setPopup({
      isPopup: true,
      message: '',
      isOk: false,
      isDelete: false,
      isLoading: true,
      loadingMessage: 'Adding event, please wait!',
    });

    if (this.files.length == null || this.title == '') {
      this.passDataService.setPopup({
        isPopup: true,
        message: 'Title and image fields are mandotary',
        isOk: true,
        isDelete: false,
        isLoading: false,
        loadingMessage: '',
      });
      return;
    }

    const data = await this.eventLogicService
      .addEventLogic(
        this.title,
        this.description,
        this.location,
        this.startDate,
        this.endDate,
        this.ticketType,
        [{
          actualPrice: this.actualPrice,
          discountedPrice: this.discountedPrice,
          currency: "usd"
        }],
        this.registerLink,
        this.files
      )

    if (data?.message == "Event added succesfully") {
      this.router.navigate(['/page/events-list']);
      this.dashboardLogicService.getAllSlokaTypesAndSlokas().subscribe();

      this.passDataService.setPopup({
        isPopup: true,
        message: data?.message,
        isOk: true,
        isDelete: false,
        isLoading: false,
        loadingMessage: '',
      });
    } else {

      this.passDataService.setPopup({
        isPopup: true,
        message: 'Error while adding event. Please try again later.',
        isOk: true,
        isDelete: false,
        isLoading: false,
        loadingMessage: '',
      });
    }

  }

  onEditClick() {
    this.state.isEdit = !this.state.isEdit;
    this.state.isView = !this.state.isView;
  }

  async onUpdateClick() {
    this.passDataService.setPopup({
      isPopup: true,
      message: '',
      isOk: false,
      isDelete: false,
      isLoading: true,
      loadingMessage: 'Updating event info, please wait!',
    });

    if (this.title == '' || this.description == '') {
      this.passDataService.setPopup({
        isPopup: true,
        message: 'Title and description are mandatory',
        isOk: true,
        isDelete: false,
        isLoading: false,
        loadingMessage: '',
      });
      return;
    }

    const data = await this.eventLogicService
      .updateEventLogic(
        this._id,
        this.title,
        this.description,
        this.location,
        this.startDate,
        this.endDate,
        this.ticketType,
        [{
          actualPrice: this.actualPrice,
          discountedPrice: this.discountedPrice,
          currency: "usd"
        }],
        this.registerLink,
        this.files,
        this.state.data.imageUrls
      )

    if (data?.message == "Event updated succesfully") {
      this.router.navigate(['/page/events-list']);
      this.dashboardLogicService.getAllSlokaTypesAndSlokas().subscribe();

      this.passDataService.setPopup({
        isPopup: true,
        message: data.message,
        isOk: true,
        isDelete: false,
        isLoading: false,
        loadingMessage: '',
      });
    }

  }

  onImageDelete(link: string) {

    this.passDataService.setPopup({
      isPopup: true,
      message: 'Are you sure to delete this image?',
      isOk: false,
      isDelete: true,
      response: '',
    });

    this.passDataService
      .getPopupAction()
      .pipe(
        filter((a) => a != '' || a != null || typeof a != 'undefined'),
        map((b) => b == 'delete'),
        filter((c) => c),
        switchMap(async (d) => {
          this.passDataService.setPopup({
            isPopup: true,
            message: '',
            isOk: false,
            isDelete: false,
            isLoading: true,
            loadingMessage: 'Deleting image, please wait!',
          });
          const data = await this.eventLogicService.deleteEventImageLogic(this._id, link, this.imageUrls)
          return data;
        })
      )
      .subscribe((v: any) => {
        if (v.message == 'success') {
          this.imageUrls = v?.links;
          this.state.data.imageUrls = v?.links
          this.dashboardLogicService.getAllSlokaTypesAndSlokas().subscribe();
          this.passDataService.setPopup({
            isPopup: true,
            message: 'Image deleted successfully!',
            isOk: true,
            isDelete: false,
            response: '',
          });
        } else {
          this.passDataService.setPopup({
            isPopup: true,
            message: 'Error while deleting image. pLease try again later.',
            isOk: true,
            isDelete: false,
            isLoading: false,
            loadingMessage: '',
          });
        }
      });
  }

}
